import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { WithTranslations } from '@wilson/interfaces';
import { EntityLangType, LocalizationState } from '@wilson/localization';
import { WithDescriptions } from '@wilson/interfaces';

@Injectable({
  providedIn: 'root',
})
export class TransformMasterDataTranslationService {
  private store = inject(Store);

  transform<T extends Partial<WithTranslations>>(
    data: T[],
    lang?: EntityLangType,
  ): (T & { translatedName: string })[] {
    const nameDescriptor =
      lang || this.store.selectSnapshot(LocalizationState.getEntityLang);

    return data.map((rawData) => ({
      ...rawData,
      translatedName: rawData[nameDescriptor] || rawData.nameEn || '',
    }));
  }

  transformDescriptions<T extends Partial<WithDescriptions>>(
    data: T[],
  ): (T & { translatedDescription: string })[] {
    const nameDescriptor = this.store.selectSnapshot(
      LocalizationState.getEntityLang,
    );
    const descriptionDescriptor = nameDescriptor.replace(
      'name',
      'description',
    ) as keyof WithDescriptions;
    return data.map((rawData) => ({
      ...rawData,
      translatedDescription:
        rawData[descriptionDescriptor] || rawData.descriptionEn || '',
    }));
  }
}
